export default function promiseAllSettled(arr) {
  const result = [];
  let c = 0;
  return new Promise((resolve, reject) => {
    arr.forEach((ar, index) => {
      ar.then((value) => {
        result[index] = {
          status: "fulfilled",
          value,
        };
        c++;
        if (c === arr.length) {
          resolve(result);
        }
      }).catch((err) => {
        result[index] = {
          status: "rejected",
          reason: err,
        };
        c++;
        if (c === arr.length) {
          resolve(result);
        }
      });
    });
  });
}